import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ddr-content',
  templateUrl: './content.component.html',
  styleUrls: ['./content.component.css']
})
export class ContentComponent implements OnInit {

  constructor() {
   
  }

  ngOnInit() {
  }

}
